module.exports = __webpack_public_path__ + "img/havefun_modelcourse_2_jp.e8105019.jpg";